import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { Checkbox } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface TermsAndConditionsConfirmationProps {
  onTermsClick: (isChecked: boolean) => void;
  termsAccepted: boolean;
  className?: string;
}

export const TermsAndConditionsConfirmation: React.FC<
  TermsAndConditionsConfirmationProps
> = ({ onTermsClick, termsAccepted, className }) => {
  const [block, cn] = useModuleBEM(styles, "TermsAndConditionsConfirmation");
  const {
    brand: { urls },
  } = useI18nContext();

  const onViewHSBCTermsLink = () => {
    window.open((urls as { hsbcTerms?: string }).hsbcTerms, "_blank");
  };

  const onViewHopperTermsLink = () => {
    window.open(urls.termsAndConditions, "_blank");
  };

  const onViewPrivacyPolicyLink = () => {
    window.open(urls.privacyPolicy, "_blank");
  };

  return (
    <div className={clsx(block, className, { [cn("checked")]: termsAccepted })}>
      <span className={cn("text")}>
        <Trans
          i18nKey="review.termsAndConditionsText"
          components={[
            <span className={cn("terms-link")} onClick={onViewHSBCTermsLink} />,
            <span
              className={cn("terms-link")}
              onClick={onViewHopperTermsLink}
            />,
            <span
              className={cn("terms-link")}
              onClick={onViewPrivacyPolicyLink}
            />,
          ]}
        />
      </span>
      <span className={cn("checkbox")}>
        <Checkbox onCheckedChange={onTermsClick} />
      </span>
    </div>
  );
};
